export const ServicesContainer = () => {
  return 'Раздел услуги находится в разработке...';
};
